import type { TaskTimelineEntry } from '@erp/rpc';
import type { useGT } from 'gt-react';

/** Lifecycle success only says the executor finished; task outcomes are separate. */
export function taskRunOutcomeLabel(
  outcome: string | null | undefined,
  status: string,
  gt: ReturnType<typeof useGT>,
): string {
  if (outcome === 'needs_input')
    return gt('Needs Input', { context: 'recorded task outcome' });
  if (outcome === 'failed')
    return gt('Task Failed', { context: 'recorded task outcome' });
  if (outcome === 'completed')
    return gt('Task Completed', { context: 'recorded task outcome' });
  if (status === 'running')
    return gt('Running', { context: 'agent execution lifecycle' });
  if (status === 'failed')
    return gt('Run Failed', { context: 'agent execution lifecycle' });
  return gt('Run Finished', {
    context: 'agent finished without a recorded task outcome',
  });
}

export function recordedTimelineAgentName(
  entry: TaskTimelineEntry,
): string | null {
  if (entry.kind === 'agent_run') return entry.runSummary?.agentName ?? null;
  if (entry.kind === 'operator_step') return entry.agentName ?? null;
  return null;
}
